<template>
  <div class="picker-container" ref="pcontainer">
    <div id="picker"></div>
  </div>
</template>

<script>
import MobileSelect from 'mobile-select'
export default {
  name: "TopicPicker",
  props: {
    topics: {
      type: Array,
      default: function () { return [] }
    },
  },
  mounted() {
    let self = this
    var mobileSelect5 = new MobileSelect({
      trigger: "#picker",
      title: "Topic",
      wheels: [
        {data: self.topics}
      ],
      cancelBtnText: "Cancel",
      ensureBtnText: "Select",
      callback:function(indexArr, data){
        self.$emit('input', data[0])
        self.$emit('picked')
      },
      onShow: function() {
        // self.$refs.pcontainer
        // console.log(self.$refs.pcontainer)
        $('.mobileSelect-show').appendTo(self.$refs.pcontainer)
      }
    });
    mobileSelect5.show()
    // Pak op en plaats in .picker-container
    // $('.mobileSelect-show')
  }
}


</script>

<style lang="scss">
.mobileSelect {
  font-family: 'Roboto', sans-serif ;

  .content {
    position: relative !important;
    display: flex;
    flex-direction: column;
  }

  .grayLayer {
    display: none !important;
  }

  .panel {
    order: 1;
  }
  
  .btnBar {
    order: 2;
    height: 70px !important;
    
    .fixWidth {
      display: flex;
      width: 100%;
    }

    .cancel,
    .title {
      display: none !important;
    }

    .cancel,
    .ensure {
      flex: 1;
      color: #fff !important;
      width: auto !important;
      height: 70px !important;
      position: relative !important;
      font-size: 20px !important;
      font-weight: bold;
      text-align: center !important;
      border-radius: 0 !important;
      justify-content: center;

      &:hover {
        transform: scale(1) !important;
      }
    }
    .cancel {
      background-color: red !important;
      border-color: red !important;
      max-width: 100px;
    }
  }

  .content .panel .selectLine {
    border-top: 3px solid var(--primary);
    border-bottom: 3px solid var(--primary);
  }
  .content .panel .wheel .selectContainer li {
    color: var(--primary);
    font-weight: bold;
    text-align: left;
    padding-left: 15px;
  }
}


</style>